



















































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { Facility } from '@/models/jobs/facility';
import { vxm } from '@/store.vuex';
import { ATSJobListParams } from '@/models/jobs/atsjoblistparams';
import Referrals from './../Referrals.vue';
import MapViewJobPager from './MapViewJobPager.vue';
import { ApplyRequestWrapper } from '@/models/jobs/jobapply';
import { Referral } from '@/models/referrals/referral';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '@/router';
import MessageModal from './../Commons/MessageModal.vue';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import { JobTagConfig } from '@/models/jobs/jobtagconfig';

import ReferralProgramusd from './../SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from './../SvgIcons/ReferralProgramgbp.vue';
import { Pager } from '@/models/jobs/pager';
import { Marker } from '@/models/jobs/mapview/Marker';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

declare var google: any;
declare var window: any;

@Component({
  name: 'JoblistingMapView',
  components: {
    Referrals,
    MapViewJobPager,
    ReferralProgramusd,
    ReferralProgramgbp,
    JobMainInfo,
  },
})
export default class JoblistingMapView extends Vue {
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private jobListing: Job[] = [];
  private expandedJobs: number[] = [];
  $wlToastr: any;
  $moment: any;
  private locationType: string = '';
  private locShortName: string = '';
  private bookmarks: any[] = [];
  public message = 'Your application is being reviewed';
  private externalUrl = '';
  public externalJobId = '';
  public localjobs: Job[] = [];
  private mapView: any = null;
  private defaultMapZoom: any = 5;
  private googleMarkers: any[] = [];
  private showJobDetails: boolean = false;
  private geoLocationError: boolean = false;

  // Initialize the map
  async initMapView() {
    const center = await this.getCenterLocation();
    const zoom = this.computeZoom(center.lng, center.locationType);
    this.mapView = new google.maps.Map(document.getElementById('mapview')!, {
      zoom: zoom || this.defaultMapZoom,
      center: center,
      gestureHandling: 'cooperative',
    });
    try {
      const elements = document.getElementsByClassName('app-body-height');
      document.getElementById('mv-wrapper')!.style.height = (elements && elements.length? elements[0].clientHeight - 16 : 320) + 'px';
    } catch (exc) {
      console.log(exc);
    }
  }

  // Gets the default location, priority for user selection, then facility location
  async getCenterLocation() {
    const jobListParams = vxm.jobs.JobListParamsV2;
    const latLong = jobListParams.locationInfo.latLong;
    const locationType = jobListParams.locationInfo.locationType;

    // If location selected on job filter we pick that location as the center
    if (latLong && latLong.latitude) {
      return {
        lat: latLong.latitude,
        lng: latLong.longitude,
        locationType: locationType,
      };
    }

    const userLocation = await this.getUserLocation();
    if (userLocation) {
      return { lat: userLocation.lat, lng: userLocation.lng, locationType: '' };
    }

    // Else, we are picking the location of the first job as the center
    if (this.myJobs && this.myJobs.length) {
      const job = this.myJobs[0];
      return {
        lat: job.facility.latitude,
        lng: job.facility.longitude,
        locationType: '',
      };
    }

    // Default center, Central United States latLong
    return { lat: 30.55435, lng: -91.03677 };
  }

  computeZoom(lng, locationType) {
    // Default zoom for country established to 7
    const defaultZoom = 5;
    if (locationType === 'country') {
      return defaultZoom;
    }

    const km = vxm.jobs.FilterRadius * 1.60934;
    const parallelMultiplier = Math.cos((lng * Math.PI) / 180);
    // const center = this.mapView.getCenter();
    let zoom = defaultZoom;
    if (parallelMultiplier > 0) {
      zoom = Math.log2((38000 * parallelMultiplier) / km) + 3;
    }
    return zoom;
  }

  @Watch('myJobs')
  async updateMap() {
    if (null == this.mapView) {
      await this.initMapView();
    } else {
      // Center the location
      const latLong = await this.getCenterLocation();
      const center = new google.maps.LatLng(latLong.lat, latLong.lng);
      const zoom = this.computeZoom(latLong.lng, latLong.locationType);
      this.mapView.panTo(center);
      this.mapView.setZoom(zoom);
    }

    this.clearMarkers();

    const pg = vxm.jobs.MapViewJobPager;
    pg.resultCount = pg.totalPages = this.loadedJobs.length;
    pg.resultSize = 1;
    //pg.resultPage = page && page.resultPage? page.resultPage : 1;
    //vxm.jobs.setMapViewJobPager(pg);

    const markers: Marker[] = [];
    // Prepare the job labels
    this.loadedJobs.forEach((job) => {
      if (job.facility && job.facility.latitude && job.facility.longitude) {
        let marker = markers.find(
          (x) =>
            x.lat == job.facility.latitude && x.lng == job.facility.longitude,
        );
        if (marker) {
          marker.count++;
        } else {
          let marker = new Marker();
          marker.count = 1;
          marker.lat = job.facility.latitude;
          marker.lng = job.facility.longitude;
          markers.push(marker);
        }
      }
    });

    markers.forEach((label) => {
      if (label.count) {
        let marker = this.addGoogleMapMarker(
          this.mapView,
          { lat: label.lat, lng: label.lng },
          label.count + '',
          label.count + ' jobs',
        );
        marker.addListener('click', () => {
          this.toggleShowJobDetails();
        });
      }
    });
  }

  get loadedJobs(): Job[] {
    return vxm.jobs.MapViewJobListing;
  }

  get hasJob() {
    return vxm.jobs.MapViewJobListing && vxm.jobs.MapViewJobListing.length > 0;
  }

  get job() {
    if (this.loadedJobs && this.loadedJobs.length) {
      const page = vxm.jobs.MapViewJobPager.resultPage || 1;
      return this.loadedJobs[page - 1];
    }
    return null;
  }

  toggleShowJobDetails() {
    this.showJobDetails = !this.showJobDetails;
  }

  async getUserLocation() {
    if (!navigator.geolocation) {
      //this.$wlToastr('warning', 'Your browser doen\'t support geolocation.', 'Find Jobs');
      return null;
    }
    const getCurrentPosition = () =>
      new Promise((resolve, error) =>
        navigator.geolocation.getCurrentPosition(resolve, error),
      );
    try {
      let position: any = await getCurrentPosition();
      return {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    } catch (error) {
      console.log('getCurrentPosition error =>', error);
      if (!this.geoLocationError) {
        this.geoLocationError = true;
        this.$wlToastr(
          'warning',
          'Please Allow your location for best results',
          'Find Jobs',
        );
      }
      return null;
    }
  }

  // Adds a marker to the map.
  addGoogleMapMarker(map, location, label, title) {
    let marker = new google.maps.Marker({
      position: location,
      label: label,
      title: title,
      map: map,
    });
    this.googleMarkers.push(marker);
    return marker;
  }

  clearMarkers() {
    this.googleMarkers.forEach((marker) => {
      marker.setMap(null);
    });
    this.googleMarkers = [];
  }

  get showMapView() {
    return vxm.jobs.getMapViewMode;
  }

  get canShowChat() {
    return false
  }

  get canShowBookMark() {
    return (job) => {
      if (this.isLoggedIn) {
        return !job.hasAppliedJob;
      }
      return vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS');
    };
  }

  formattingJobDescription(jobDescription: any) {
    if (jobDescription && jobDescription.startsWith('<p>')) {
      return jobDescription.slice(3);
    }
    return jobDescription;
  }

  get isJobLevelChat() {
    return false
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  bookmarkJob(job: any) {
    if (!this.isLoggedIn) {
      if (!vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS'))
        return;
      const found = this.localjobs.find(
        (element) => element.jobPostingId == job.jobPostingId,
      );
      if (found) {
        const vm = this;
        console.log('got job:' + job.jobPostingId);
        this.localjobs.forEach((item, index) => {
          if (item.jobPostingId == job.jobPostingId) {
            this.localjobs.splice(index, 1);
          }
        });
        localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
        vxm.utility.setLocaljobs(this.localjobs);
        vm.$wlToastr('success', vm.$t('MyJobListing_JobUnsavevSuccess'), vm.$t('savedJobs.text'));
      } else {
        const vm = this;
        this.localjobs.push(job);
        localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
        vxm.utility.setLocaljobs(this.localjobs);
        vm.$wlToastr('success', vm.$t('MyJobListing_JobSavedSuccess'), vm.$t('savedJobs.text'));
      }
      return;
    } else {

      job.bookmarkStatus = job.bookmarkStatus === 'A' ? 'D' : 'A';

      let jobs = this.bookmarks.filter(
        (bookmark) => bookmark.objectId === job.jobPostingId,
      );
      if (jobs && jobs.length > 0) {
        for (let bookmark of this.bookmarks) {
          bookmark.action = job.bookmarkStatus;
        }
      } else {
        this.bookmarks.push({
          action: job.bookmarkStatus,
          type: '01',
          objectId: job.jobPostingId,
        });
      }

      let req = {
        sessionToken: '13223',
        bookmarks: this.bookmarks,
      };
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  getJobTags(jobTags: string) {
    if (jobTags) {
      let jobTagValues = new Set(jobTags);
      let jobTagConfigs: JobTagConfig[] = vxm.jobs.JobTagConfigs;
      if (jobTagConfigs && jobTagConfigs.length > 0) {
        return jobTagConfigs
          .filter((tagConf) => jobTagValues.has(tagConf.tagName))
          .sort((a, b) => a.sequence - b.sequence);
      }
    }
    return [];
  }

  goTodetail2(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    this.$router.push({
      path: `/jobdetails/${jid}?apply=true`,
    });
  }

  goTodetail(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    localStorage.jobviewpage = true;
    this.$router.push({
      name: 'Jobdetails',
      params: { JobID: jid },
    });
  }

  goTodetailWithTitle(jid: string, jTitle: string, facility: Facility) {
    if (this.$cookies.get('SubmitJobApplicationId')) {
      this.$cookies.remove('SubmitJobApplicationId');
    }
    vxm.jobs.setJobID(parseInt(jid, 10));
    let city = facility.city ? facility.city.trim() : facility.city;
    localStorage.jobviewpage = true;
    let jobTitleSlug = this.jobTitleCitySlug(jTitle, city);
    this.$router.push({
      name: 'JobdetailsSlug',
      params: { JobID: jid, JobSlug: jobTitleSlug },
    });
  }

  jobTitleCitySlug(jTitle: string, city: string): string {
    let slug = '';
    slug = jTitle.toLowerCase();
    slug = slug.replace(/\/|\s/g, '-');
    if (city !== null && city.length > 0) {
      slug = slug.concat('-in-').concat(city.toLowerCase());
    }
    slug = slug.replace(/---|-\/-/g, '-');
    return slug;
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  goToUpload(jid: string, externalJobUrl: string) {
    const vm = this;
    if (!vxm.users.getToken) {
      this.setNavigation('JobDetails:' + jid);
      //this.$router.push({ name: 'Login' });
      if (externalJobUrl != null) {
        this.showPopup(
          'Login',
          this.$t('Jobdetails_LoginPrompt').toString(),
          jid,
        );
      } else {
        this.$cookies.set('SubmitJobApplicationId', jid, 600);
        this.$router.push({ name: 'Login' });
      }
    } else {
      if (externalJobUrl != null) {
        this.showPopup(
          externalJobUrl,
          vxm.jobs.BrandingInfo.JOB_REDIRECTION_PROMPT!==''?
          vxm.jobs.BrandingInfo.JOB_REDIRECTION_PROMPT.toString():
          this.$t('Jobdetails_RedirectionPrompt').toString(),
          jid,
        );
      } else {
        this.applyJob(jid);
      }
    }
  }

  applyJob(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    const jobApply = new ApplyRequestWrapper();
    jobApply.accessToken = vxm.users.getToken;
    jobApply.applyRequest.jobPostingId = parseInt(jid, 10);

    jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
    const respPromise: any = vxm.jobs.getNexSteps(jobApply);
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((values) => {
      this.$modal.hide('survey-spinner');
      const resp = values[0] && values[0].data ? values[0].data : values[0];
      if (resp) {
        this.processJobApplicationResponse(resp, jid);
      }
    });
  }

  showPopup(externalJobUrl: string, message: string, jid: string) {
    this.externalUrl = externalJobUrl;
    this.externalJobId = jid;
    var msgModal =
      externalJobUrl == 'Login'
        ? this.openExtUrlWindowWithoutLogin
        : this.openExtUrlWindow;
    this.$modal.show(
      MessageModal,
      {
        body: message,
        onOk: msgModal,
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  openExtUrlWindow() {
    this.applyJob(this.externalJobId);
    window.open(this.externalUrl, '_blank');
  }

  openExtUrlWindowWithoutLogin() {
    this.$router.push({ name: 'Login' });
  }

  processJobApplicationResponse(apply, jid) {
    if(apply.questionareInfo){
      localStorage.hasBranchedQuestions = apply.questionareInfo.hasBranchedQuestions;
      localStorage.questionTemplate   = apply.questionareInfo.questionTemplateId;
    }
    if (apply.nextPage === 'otpauthentication') {
      if (vxm.utility.useLoginSignupV2) {
        this.$cookies.set('SubmitJobApplicationId', jid, 600);
      }
      this.$router.push({ name: 'Verification' });
      this.setNavigation('JobDetails:' + jid);
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
      localStorage.jobviewpage = '';
      this.goTodetail2(jid);
      return;
    }

    if (apply.errorCode === '1002') {
      this.showMessage(apply, jid);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply, jid);
      return;
    }
    this.showMessage(apply, jid);
  }

  destroyed() {
    localStorage.nextpage = '';
  }

  showMessage(value, jid) {
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002') {
          const errorMessageText = value.errorMessage;
          this.$wlToastr('error', errorMessageText, this.$t('MyJobListing_JobApplication'));
        }
      } else {
        if (value.nextPage === 'success') {
          vxm.users.Rudderstack.trackEvent("Job Apply Submitted", { jobPostingId: jid });
          const successMessage = this.$t('jobs.successfully.applied');
          this.$wlToastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
          vxm.jobs.setAppliedJob(jid);
          this.$router.push({ name: 'JobApplicationSuccess', params: { jid } });
        }
      }
    }
  }

  get referralEnabled(){
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  get showApplyButtonOnJobCard() {
    return vxm.configs.getGlobalConfigValue('SHOW_APPLY_BUTTON_ON_JOB_CARD') !== false;
  }

  goToReferral(job) {
    let jid = job.jobPostingId;
    let jobName = job.jobPostingName;
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(jobName);
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    if (vxm.users.isLoggedIn === false) {
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(jid, 10);
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      referral.referralCode = '';
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive !== null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }

  toggleReferralIndex(jobPostingId) {
    const i = this.expandedJobs.findIndex((elm) => {
      return elm === jobPostingId;
    });
    if (i === -1) {
      this.expandedJobs.push(jobPostingId);
    } else {
      this.expandedJobs.splice(i, 1);
    }
  }

  get isExpanded() {
    return (jobPostingId) => {
      const isPresent = this.expandedJobs.find((elm) => {
        return elm === jobPostingId;
      });
      return !!isPresent;
    };
  }

  getJobTagStyle(jobTagObj) {
    let styleObj = {};
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.fontColor
    ) {
      styleObj['color'] = jobTagObj.meta.style.fontColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColor
    ) {
      styleObj['background'] = jobTagObj.meta.style.backgroundColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColorOpacity
    ) {
      styleObj['opacity'] = jobTagObj.meta.style.backgroundColorOpacity;
    }
    return styleObj;
  }

  get myJobs(): Job[] {
    let jobs = vxm.jobs.Jobs;
    //this.initMapView();
    if (jobs) {
      jobs.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
      );
      return jobs;
    } else {
      return [];
    }
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  renderDate(xDate: number): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return this.$moment(xDate).format(
        vxm.jobs.getCompanyDateFormat.toUpperCase(),
      );
    }
    return this.$moment(xDate).format('DD-MMM-YYYY');
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  beforeMount() {
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
    }
    const pg = new Pager();
    pg.resultCount = 0;
    pg.totalPages = 0;
    pg.resultPage = 1;
    pg.resultSize = 1;
    vxm.jobs.setMapViewJobPager(pg);
  }

  renderDOW(dow: number): string {
    let day = '';
    switch (dow) {
      case 0:
        day = 'Sun';
        break;
      case 1:
        day = 'Mon';
        break;
      case 2:
        day = 'Tue';
        break;
      case 3:
        day = 'Wed';
        break;
      case 4:
        day = 'Thu';
        break;
      case 5:
        day = 'Fri';
        break;
      case 6:
        day = 'Sat';
    }
    return day;
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  get bookmarkClass() {
    return (job) => {
      if (
        vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS') &&
        !this.isLoggedIn
      ) {
        if (
          this.localjobs.find(
            (savedJob) => savedJob.jobPostingId === job.jobPostingId,
          )
        ) {
          return 'fa fa-bookmark secondary-color bookmark-icon';
        } else {
          return 'fa fa-bookmark-o remove-color bookmark-icon';
        }
      }
      let jobs = this.bookmarks.filter(
        (bookmark) => bookmark.objectId === job.jobPostingId,
      );
      if (
        ((job.bookmarkStatus && job.bookmarkStatus === 'A') ||
          (jobs && jobs.length && jobs[0].action === 'A')) &&
        job.hasAppliedJob != true
      ) {
        return 'fa fa-bookmark secondary-color bookmark-icon';
      } else {
        return 'fa fa-bookmark-o remove-color bookmark-icon';
      }
    };
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value.trim().charAt(0).toUpperCase();
  }

  saveJobAlert() {
    const vm = this;
    vm.$wlToastr(
      'success',
      vm.$t('jobalert-saved-success-message'),
      vm.$t('JobAlert_JobAlert'),
    );
  }
  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }
  async fetchConversation(job: Job) {
    console.log('job----------------------------------->>>>', job);

    let accessTkn = vxm.users.getUserProfile();
    console.log(accessTkn, '<<<----------------accessTkn');
    try {
      let conversationResponse = await vxm.jobs.fetchExistingConversation({
        adminId: job.createdByUserId,
        userId: vxm.users.myUserProfile.userId,
        contextType: '01',
        contextId: job.jobPostingId,
        conversationType: '01',
        isAdmin: true,
      });
      console.log('Response is : ', conversationResponse);
      if (conversationResponse.conversationGUID !== null) {
        vxm.jobs.setActiveConversationGUID(
          conversationResponse.conversationGUID,
        );
        console.log('value of guid is : ', vxm.jobs.ActiveConversationGUID);
      } else {
        try {
          let sendMessage = await vxm.jobs.sendMessage({
            isAdmin: false,
            originId: vxm.users.myUserProfile.userId,
            conversation: {
              conversationGUID: null,
              initiatedBy: vxm.users.myUserProfile.userId,
              claimedBy: vxm.users.myUserProfile.userId,
              participants: [job.createdByUserId],
              context: '01',
              contextId: job.jobPostingId,
              companyCode: vxm.users.getCompanyCode,
            },
            conversationMessage: {
              origin: vxm.users.myUserProfile.userId,
              messageType: '01',
              messageText: '',
              destination: job.createdByUserId,
            },
          });
          //set in store
          vxm.jobs.setActiveConversationGUID(sendMessage.conversationGUID);
        } catch (error) {
          var uri = window.origin + '/atsuser/chat';
          console.log('uri', uri);
          (window as any).location = uri;
        }
      }
      this.$router.push({ name: 'Chat' });
    } catch (error) {
      console.log(error, '--------------------------error');
    }
  }
  mounted() {
    this.updateMap();
  }
}
